module.exports = __webpack_public_path__ + "media/bootstrap-icons/files-alt-c463e972.svg";